import React, { useMemo } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import { getRoutesParams } from "v4/data/appRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import Router from "../Router/router";
import Header from "../Header/header";
import Admin from "../Admin/admin";
import Loading from "../Loading/Loading";
import PolRouter from "v4/features/front/routing/components/PolRouter/PolRouter";
import DynamicRouter from "v4/features/front/navigation/components/DynamicRouter/DynamicRouter";
import UserService from "../../api/user/user";
import {FrontProvider} from "v4/contexts/FrontContext";
import ExportPopup from "v4/features/front/export/components/ExportPopup/ExportPopup";
import SwitchUserBanner from "v4/features/front/auth/components/SwitchUserBanner/SwitchUserBanner";


const Layout = ({ router, t, loader }) => {
    const { pathname } = useLocation();
    const { currentRoute, isReady} = useNavigation();
    const isReduxLoading = Object.keys(loader).filter((key) => !!loader[key]).length > 0;

    const routeV4 = useMemo(() => {
        const route = getRoutesParams().find(({ basePath }) => pathname.startsWith(basePath));

        // As the login route is '/', it catches all paths, so we need to check if
        // the current path is really the login route
        if (route?.id === "login" && pathname !== route.basePath) return undefined;

        return route;
    }, [pathname]);

    if (currentRoute?.routeConfig.isExternal) {
        const Component = currentRoute.routeConfig.component;

        return <Component key={currentRoute.route.url || currentRoute.route.native_identifier}/>;
    }

    // Not logged in or routeV4 is external
    if (!UserService.isLogged() || routeV4?.isExternal) {
        return <PolRouter isExternal={routeV4?.isExternal} isProtected={routeV4?.isProtected}/>
    }

    if (router.isAdmin || routeV4?.isAdmin) {
        return (
            <>
                <SwitchUserBanner/>
                <ExportPopup/>
                {isReduxLoading ? <Loading message={t("loading")} specificClass={"admin-loader"}/> : null}
                <Admin>
                    {routeV4 ? <PolRouter isProtected={routeV4.isProtected}/> : <Router/>}
                </Admin>
            </>
        )
    }

    return (
        <>
            <SwitchUserBanner/>
            <ExportPopup/>
            <FrontProvider
                header={() => <Header/>}
                body={
                    <main className="wrap-content main-content">
                        <div className="main-content__body">
                            {!isReady ? (
                                <InlineLoader/>
                            ) : (
                                currentRoute.route?.native_identifier !== 'main_not_found'
                                    ? <DynamicRouter/>
                                    : (routeV4 ? <PolRouter isProtected={routeV4.isProtected}/> : <Router/>)
                            )}
                        </div>
                    </main>
                }/>
        </>

    )
};


const mapStateToProps = ({ router, content: { loader } }) => ({
    router,
    loader
});

export default connect(
    mapStateToProps,
    null
)(withTranslation()(Layout))
